import React from 'react';
import * as actions from '../actions';
import componentServices from '../componentServices';
import contactModel from '../models/contactModel';
import ContactEdit from './contactEdit';

import { Confirm } from './sharedComponents';

export default class ContractorContactEdit extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.handleDeleteClick = this.handleDeleteClick.bind(this);
		this.updateModel = this.updateModel.bind(this);
		this.validateContact = this.validateContact.bind(this);
	}

	handleDeleteClick () {
		const popup = <Confirm title={ 'Permanently Delete Contact?' } message={ 'Are you sure you want to permanently delete this Contact? This cannot be undone.' } confirmLabel="Permanently Delete" cancelLabel="Cancel" cancelHandler={ actions.popModal } confirmHandler={ this.doDelete.bind(this) } />;

		actions.pushModal({ component: popup });
	}

	doDelete () {
		const contactKey = componentServices.routeParams.contactkey;

		actions.popModal();

		this.props.updateModel(model => {
			model.contacts.delete(contactKey);
			componentServices.router.replaceHistory(componentServices.router.popPathSegment());
		}, { autoSave: true });
	}

	validateContact (contact, property) {
		return contact.isEmpty() || contact.isValid(property);
	}

	updateModel (updater, options) {
		const contactKey = componentServices.routeParams.contactkey;

		this.props.updateModel(model => {
			let contact = model.contacts[contactKey];

			if (!contact) {
				contact = model.contacts.add({ key: contactKey, priority: 2 }); // these should not be "primary" contacts
			}

			updater(contact);
		}, options);
	}

	render () {
		const { contractor } = this.props;
		const contactKey = componentServices.routeParams.contactkey;
		const contact = contractor.contacts[contactKey] || contactModel({ priority: 2 }); // these should not be "primary" contacts

		return (<React.Fragment>
			<ContactEdit
				contact={ contact }
				hideHeader={ true }
				validate={ this.validateContact }
				updateModel={this.updateModel } />
			<footer><div className="actions"><button className="labelOnly deleteItem" onClick={ this.handleDeleteClick }>Permanently Delete this Contact</button></div></footer>
		</React.Fragment>);
	}
}